export default class BulgarianEuroConversionService {
    constructor() {
        this.BGN_TO_EUR_RATE = 1.95583;
    }

    convertBgnToEur(amount) {
        if (!amount) {
            return 0;
        }

        return amount / this.BGN_TO_EUR_RATE;
    }

    convertEurToBgn(amount) {
        if (!amount) {
            return 0;
        }

        return amount * this.BGN_TO_EUR_RATE;
    }

    isBgn(currency) {
        return currency === 'BGN';
    }

    isEur(currency) {
        return currency === 'EUR';
    }
}
